import { Outlet, useNavigation } from 'react-router';
import { AccountDrawer, Sidebar, Toasts, UserChip } from '@/features/portal';

/** `.app > aside.sidebar + main.main` with the user chip, account drawer and toasts mounted once. */
export function AppShell() {
  const navigation = useNavigation();
  return (
    <>
      <div className="app" aria-busy={navigation.state !== 'idle' || undefined}>
        <Sidebar />
        <main className="main">
          <UserChip />
          <Outlet />
        </main>
      </div>
      <AccountDrawer />
      <Toasts />
    </>
  );
}
